<template lang="html">
  <div>
    <vs-card v-if="!displayForm" class="cardx">
      <div slot="header" style="padding: 10px">
        <h3>Routes</h3>
      </div>
      <div>
        <div class="vx-row"></div>
        <vs-table :data="routes.routes">
          <template slot="header">
            <vs-row style="margin-bottom: 20px">
              <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
                <vs-row>
                  <div style="margin-bottom: 5px; margin-left: 0px">
                    <vs-button
                      @click="MassLoad"
                      color="primary"
                      type="filled"
                      icon="arrow_downward"
                      size="small"
                      >Import</vs-button
                    >
                  </div>

                  <div style="margin-bottom: 5px; margin-left: 15px">
                    <vs-button
                      @click="Exportxls"
                      color="primary"
                      type="filled"
                      icon="arrow_upward"
                      size="small"
                      >Export</vs-button
                    >
                  </div>

                  <div style="margin-bottom: 5px; margin-left: 15px">
                    <a href="/admin/routes/add" target="_self">
                      <vs-button
                        color="primary"
                        type="filled"
                        icon="add"
                        size="small"
                        >New</vs-button
                      >
                    </a>
                  </div>
                </vs-row>
              </vs-col>
              <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
                <vs-row>
                  <vs-dropdown
                    class="mr-2"
                    vs-custom-content
                    vs-trigger-click
                    vs-drop-right
                    :vs-dropdown-visible="true"
                    style="float: right"
                  >
                    <vs-chip
                      transparent
                      color="primary"
                      style="min-width: 130px"
                    >
                      <b>From</b>: {{ since }}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker
                        @input="updateDateQuery"
                        calendar-class="border-none"
                        :inline="true"
                        v-model="dates.since"
                        format="yyyy-MM-dd"
                      ></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>

                  <vs-dropdown
                    class="mr-2"
                    vs-custom-content
                    vs-trigger-click
                    vs-drop-right
                    :vs-dropdown-visible="true"
                    style="float: right"
                  >
                    <vs-chip
                      transparent
                      color="primary"
                      style="min-width: 130px"
                    >
                      <b>To</b>: {{ until }}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker
                        @input="updateDateQuery"
                        calendar-class="border-none"
                        :inline="true"
                        v-model="dates.until"
                        format="yyyy-MM-dd"
                      ></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-row>

                <div style="margin-top: 10px; margin-bottom: 10px">
                  <label class="vs-input--label">Zone</label>
                  <v-select
                    @input="onZoneChange"
                    v-model="filters.zone_id"
                    :options="zones"
                    :reduce="(el) => el.id"
                    label="name"
                  />
                </div>
              </vs-col>
            </vs-row>
          </template>
          <template slot="thead">
            <vs-th sort-key="name"> Name </vs-th>
            <vs-th sort-key="zone"> Zone </vs-th>
            <vs-th> Stations </vs-th>
            <vs-th sort-key="distance"> Distance (km) </vs-th>
            <vs-th style="width: 120px"> Status </vs-th>
            <vs-th> Created at </vs-th>
            <vs-th style="width: 120px"> Action </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="item.id" v-for="item in data">
              <vs-td>
                {{ item.name }}
              </vs-td>
              <vs-td v-if="item.zone.name">
                {{ item.zone.name }}
              </vs-td>
              <vs-td v-else> </vs-td>

              <vs-td>
                {{ item.stations.length }}
              </vs-td>
              <vs-td>
                {{ item.distance }}
              </vs-td>
              <vs-td>
                <vs-chip
                  transparent
                  :color="item.is_active ? 'success' : 'warning'"
                >
                  {{ item.is_active ? "Enabled" : "Disabled" }}
                </vs-chip>
              </vs-td>
              <vs-td>
                {{ funcmoment(item.created_at) }}
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="EditIcon"
                  @click="edit(item.id)"
                  class="cursor-pointer navbar-fuzzy-search mr-4"
                />
                <feather-icon
                  icon="Trash2Icon"
                  @click="openConfirm(item.id)"
                  class="cursor-pointer navbar-fuzzy-search mr-4"
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="mt-3 mb-3">
          <span style="float: left">
            <vs-select
              @input="filters.page = 1"
              class=""
              label=""
              v-model="filters.limit"
              width="100px"
              size="small"
            >
              <vs-select-item
                :key="'lim-' + index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in limitOptions"
              />
            </vs-select>
          </span>
          <pagination
            :last-page="routes.pagination.pages"
            v-model="filters.page"
          />
        </div>
      </div>
    </vs-card>

    <vs-card v-if="displayForm" class="cardx card-100-h">
      <div>
        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
            <div>
              <h3 style="margin-bottom: 10px">{{ formTitle }}</h3>

              <div>
                <vs-row>
                  <vs-col
                    vs-lg="12"
                    vs-sm="12"
                    vs-xs="12"
                    style="padding: 10px"
                  >
                    <label class="vs-input--label">Zone</label>
                    <v-select
                      @input="onZoneChange"
                      v-model="filters.zone_id"
                      :options="zones"
                      :reduce="(el) => el.id"
                      label="name"
                    />
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
                    <input
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                      ref="file"
                      type="file"
                      @click="uploadFile"
                    />
                  </vs-col>
                </vs-row>
              </div>
              <div class="mb-4">
                <vs-button
                  class="mr-3"
                  @click="Masssave"
                  color="danger"
                  type="filled"
                  :disabled="showError"
                  >Guardar</vs-button
                >
                <vs-button @click="cancel" color="primary" type="filled"
                  >Cancelar</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>

        <vs-row v-if="showError">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
            <h3>Import error</h3>
          </vs-col>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
            <vs-table stripe :data="errors_array">
              <template slot="thead">
                <vs-th> Line </vs-th>
                <vs-th> Order </vs-th>
                <vs-th> Type </vs-th>
                <vs-th> Station Adress </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Code </vs-th>
                <vs-th> Station Name </vs-th>
                <vs-th> Zone Id </vs-th>
                <vs-th> Latitude </vs-th>
                <vs-th> Longitude </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="indextr">
                    {{ parseInt(Object.keys(data[indextr])) }}
                  </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].order
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .order[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].type
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .type[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .station_address
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .station_address[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].name
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .name[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].code
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .code[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .station_name
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .station_name[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .zone_id
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .zone_id[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .latitude
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .latitude[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .longitude
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .longitude[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-row>
              <vs-col style="margintop: 10px">
                <vs-button
                  @click="showError = false"
                  color="primary"
                  type="filled"
                  size="small"
                  >Ok</vs-button
                >
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>

    <vs-popup
      @close="showProgress = false"
      button-close-hidden
      class="crop-modal"
      title="Import Progress"
      :active.sync="showProgress"
    >
      <vs-row>
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
          Progress of import to {{ this.partnernamespace }}
        </vs-col>
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
          <div
            :style="{
              background: 'red',
              height: '15px',
              width: progress + '%',
            }"
          ></div>
          <div
            style="
              fontsize: 1rem;
              fontweight: bold;
              color: red;
              textalign: center;
            "
          >
            {{ progress }}%
          </div>
        </vs-col>
        <vs-col
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
          style="padding: 10px; textalign: center"
          v-if="progress === 100"
        >
          <vs-button
            @click="showProgress = false"
            color="primary"
            type="filled"
            size="small"
            >Ok</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import limitOptions from "../../constants/limit";
import moment from "moment";
const FileDownload = require("js-file-download");

export default {
  data() {
    return {
      page: 0,
      search: null,
      zone_id: null,
      formTitle: "",
      windowHeight: 0,
      filters: {},
      displayForm: false,
      showError: false,
      showProgress: false,
      progress: 0,
      errors_detail: null,
      errors_array: null,
      limitOptions: limitOptions,
      partnernamespace: "",
      dates: {
        page: 0,
        since: moment().subtract(1, "weeks").toDate(),
        until: moment().toDate(),
      },
    };
  },
  computed: {
    ...mapGetters("users", ["userCan"]),
    ...mapGetters("zones", ["zones"]),
    ...mapState("routes", ["routes", "currentPage"]),
    since() {
      return moment(this.dates.since).format("YYYY-MM-DD");
    },
    until() {
      return moment(this.dates.until).format("YYYY-MM-DD");
    },
  },
  created() {
    this.filters = {
      limit: "20",
      ...this.$route.query,
      page: this.$route.query.page ? Number(this.$route.query.page) : 1,
    };
    this.doSearch = _.debounce(this.getItems, 300);
  },
  components: {
    Datepicker,
  },
  watch: {
    filters: {
      deep: true,
      handler(newVal, oldVal) {
        this.setRouteQuery();
        //if(!_.isEqual(newVal, oldVal))
        this.doSearch();
      },
    },
  },
  mounted() {
    this.windowHeight = window.innerHeight;
  },
  methods: {
    ...mapActions("routes", [
      "fetchRoutes",
      "deleteRoute",
      "MassLoadRoutes",
      "CheckRoutesProgress",
      "fetchRoutesReport",
    ]),
    ...mapActions("partners", ["fetchPartners"]),
    ...mapMutations("routes", ["SET_ZONE_ID"]),
    setRouteQuery() {
      let query = { ...this.filters, page: `${this.filters.page}` };
      if (!_.isEqual(query, this.$route.query)) {
        try {
          this.$router.push({ query });
        } catch (error) {}
      }
    },
    onZoneChange() {
      this.filters = { ...this.filters, page: 1 };
      this.zone_id = this.filters.zone_id;
    },
    getItems(search) {
      if (!this.userCan("routes.read")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }
      this.$vs.loading({ type: "point" });

      this.fetchRoutes(_.cloneDeep(this.filters))
        .then((data) => {
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    handleSearch(searching) {
      this.filters = { ...this.filters, page: 1, search: searching };
    },
    MassLoad() {
      this.formTitle = "Mass Charge Routes";
      this.displayForm = true;
    },
    funcmoment(_time) {
      return moment(_time).format("DD-MM-YYYY");
    },
    ChangePartner() {
      console.log("ChangePartner");
    },
    uploadFile() {
      console.log("uploadFile");
      this.showError = false;
    },
    updateDateQuery() {
      console.log("update query", dates.since);
      date.since;

      this.page = 1;
      this.filters = {
        ...this.filters,
        page: 1,
        since: this.since,
        until: this.until,
      };
    },
    Exportxls() {
      console.log("export xls");

      var targetexport = {
        ...this.filters,
        export: true,
        format: "csv",
      };
      targetexport.page = 1;
      this.$vs.loading({ type: "point" });
      this.fetchRoutesReport(targetexport)
        .then((data) => {
          FileDownload(data, `routes-${this.since}-${this.until}.csv`);
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    Masssave() {
      console.log("+++SAVE ROUTES++");
      if (this.filters.zone_id) {
        console.log("+++this.zone_id++", this.zone_id);
        this.handleFilesUpload();
      } else {
        alert("Select a zone.");
      }
    },
    handleFilesUpload() {
      this.submitFile(this.$refs.file.files[0]);
    },
    checkprogress(data_id) {
      let payload = { task_id: data_id };
      this.CheckRoutesProgress(payload)
        .then((data) => {
          /* for (var i=0; i < this.partners.partners.length; i++) {
              if (this.partners.partners[i].id === this.partner_id) {
                  this.partnernamespace= this.partners.partners[i].name;
              }
          }*/
          this.progress = 0;
          console.log("CheckRoutesProgress data", data);
          this.showProgress = true;
          if (data.status === "FAILURE") {
            this.errors_array = null;
            this.errors_array = data.errors;
            this.showError = true;
            this.showProgress = false;
            this.$vs.loading.close();

            setTimeout(() => {}, 500);
            return false;
          }
          if (data.progress != 100) {
            this.progress = data.progress;
            setTimeout(() => {
              this.checkprogress(data_id);
            }, 1000);
          } else {
            this.progress = 100;
            this.displayForm = false;
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log("CheckRoutesProgress error:", error);
          alert("Error on Import.");
          this.progress = 0;
          this.showProgress = false;
          this.$vs.loading.close();
        });
    },
    submitFile(file) {
      this.$vs.loading({ type: "point" });
      let formData = new FormData();
      formData.append("file", file);
      formData.append("zone_id", this.zone_id);
      this.MassLoadRoutes(formData)
        .then((data) => {
          if (data.id) {
            this.checkprogress(data.id);
            this.$vs.loading.close();
          }
        })
        .catch((error) => {
          console.log("error:", error);
          if (error.status === 400) {
            this.errors_array = null;
            this.errors_array = error.data.errors;
            this.errors_detail = error.data.detail;
            this.showError = true;
          }
          this.$vs.loading.close();
        });
    },

    cancel() {
      this.displayForm = false;
    },
    openConfirm(id) {
      if (!this.userCan("routes.delete")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure yo want to delete this record?\n This cannot be undone!",
        accept: () => {
          this.deleteRoute({ id })
            .then((data) => {
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "Deleted successfully",
              });
              this.getItems();
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Something went wrong",
              });
            });
        },
      });
    },
    edit(id) {
      this.$router.push({ name: "routes.edit", params: { id } });
    },
  },
};
</script>
